/* ========================== */
/* ========= import ========= */
/* ========================== */
/* ====== React ====== */
import React, { useEffect, useState } from "react";
/* ====== CSS ====== */
import styled from 'styled-components';
/* ====== Image ====== */
import arrowTop from '05Images/arrowTop.svg';
import arrowUnder from '05Images/arrowUnder.svg';
import pencil from '05Images/pencil.svg';
import people from '05Images/people.svg';
/* ====== Component Js/Jsx ====== */
import { assets } from "03CommonApiParts/Configuration";
import { CFSort, CFArrayFount, CFStingMasterEdit, CFDateTimeFormatEdit, CFDateEdit } from "03CommonApiParts/CommonFunction";
import { inputCheckMaster, patternCheckMaster, SORTINFO_STORAGE } from "03CommonApiParts/CodeDefinition";
import { TableCheckOnChange } from "./TableCheckOnChange";
import { TableInputField } from "02CommonUiParts/TableParts/TableInputField";
import { TableInputList } from "02CommonUiParts/TableParts/TableInputList";
import { TableCheck, TableCnfCheck } from "./TableCheck";
import { TableSelectB } from "./TableSelect";
import { TableDateField } from "./TableDateField";
import { ButtonIconExcelTabel } from "02CommonUiParts/ButtonParts/ButtonBase";
/* ========================== */
/* ========= Styles ========= */
/* ========================== */

/* ====== Styled Components ====== */
/* ------テーブル ------*/
const SdivTableGroup = styled.div`//テーブル外枠
	display: flex;
	-webkit-flex-wrap: wrap;
	flex-wrap: wrap;

`;
const SdivPaper = styled.div`//テーブル内枠
	border-radius: 3px;
	overflow-Y: auto;
	overflow-X: ${props => props.noScroll ? 'hidden' : 'auto'};
    border: 1px solid #c0c0c0;
`;
const Stable = styled.table`//テーブル本体
	background-color: white;
    color:black;
    font-weight:normal;
	border-radius: 0px;
	border-spacing: 0;
    word-break: break-all;
	max-height: ${props => props.tableMaxHeight ? props.tableMaxHeight : 'calc(100vh - 100px)'};
    th, td{
        border-bottom: solid 0.5px #c0c0c0;
        border-left:  none;
        margin: 0;
        /* padding-left: 10px; */
    }
    tr:last-child td{
        border-bottom: none;
    }
    tr td:first-child, tr th:first-child{
        border-left: none;
    }
`;

const StrTableHeadRow = styled.tr`//テーブルヘッダー行
	z-index:30;
	background-color:${assets().color.blue};
    position: sticky;
    top: 0px;
    height: 40px;
`;
const StrTableRow = styled.tr`//テーブルボディー行
    height: 40px;
    &:hover{
        /* background-color:${props => props.hoverEffect ? assets().color.backgroundBlue : ''}; */
            cursor: ${props => props.hoverEffect ? 
                'pointer' 
            : 'default'
        };
    }
    &:hover td{
        background-color:${props => props.childBackGroundColor ? 
                props.childBackGroundColor
            : props.hoverEffect ? assets().color.backgroundBlue : ''};
    }
    td {
        background-color:${props => props.childBackGroundColor ? props.childBackGroundColor : ''}
    }
`;
const SthFixedHeadCell = styled.th`//固定ヘッダセル
    overflow-wrap: break-word;
	margin: 0px;
	font-weight: bold;
    padding:2px 4px;
	color: white;
	background-color:${assets().color.blue};
	top: 0;
	&:before{
		content: "";
		position: absolute;
		top: -1px;
		left: -1px;
	}
`;
// const SthFixedCulomnHeadCell = styled.th`//固定カラムヘッダセル
//     overflow-wrap: break-word;
// 	margin: 0px;
// 	font-weight: bold;
//     padding:3px;
// 	color: white;
// 	background-color:${assets().color.blue};
// 	position: sticky;
// 	top: 0;
// 	z-index:${props => props.tableHeadColumnZindex ? props.tableHeadColumnZindex : '40'};
// 	&:before{
// 		content: "";
// 		position: absolute;
// 		top: -1px;
// 		left: -1px;
// 	}
// `;
const StdFixedBodyCell = styled.td`//固定ボディセル
	line-height:${`calc(${assets().size.baseText}+5px);`};
    padding: 0px 4px;
    /* padding:0px; */
	margin: 0px;
    /* padding-left:10px; */
    position: sticky;
	/* top: 0;
    left:0; */
    z-index:${props => props.tableBodyZindex ? props.tableBodyZindex : '20'};
    background-color:white;
    &:before{
		content: "";
		position: absolute;
		top: -1px;
		left: -1px;
	}
`;
const StdBodyCell = styled.td`//ボディセル
	line-height:${`calc(${assets().size.baseText}+5px);`};
    padding-top: ${props => props.cellPaddingTop ? props.cellPaddingTop : ''};
	padding: 0px 4px;
    /* padding:0px; */
	margin: 0px;
    background-color: ${props => props.backgroundColor};
`;
const SdivSort = styled.div`//ソート用
	&:hover{
		cursor: pointer;
		color:#bababa
	}
`;
const SdivSortLabel = styled.div`//ソート用ラベル
    display: flex;
    align-items: center;
    user-select:none;
    /* padding-left:10px; */
`;
const SdivNoneSortLabel = styled.div`//ソート用ラベル
    display: block;
    /* align-items: center; */
    user-select:none;
    /* padding-left:10px; */
`;
const SlabelHead = styled.label`
    display: inline;
    line-height: 1.5em;
    /* width: 100%; */
`
// const SdivLabelGroup = styled.div`//入力項目一つの枠
//     display:flex;
//     flex-wrap: wrap;
//     align-items:center;
//     margin-right:15px;
// `;
const SsvgFilterIcon = styled.svg` //SVG用
    padding:0 2px;
`;
const SdivLabelWrapper = styled.div`
    height: 100%;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;
    word-break:break-word;
`;
const SsvgIconButton = styled.svg` //SVG用
    cursor: pointer;
`;

const SlabelRequireMark = styled.label`
    display: flex;
    align-items: center;
    color: ${assets().color.orange};
    height: 12px;
`;

/*==================*/
/*=====  Main  =====*/
/*==================*/
export const Table = (props) => {
    /* --------------------------- */
    /* --------- valiable -------- */
    /* --------------------------- */
    const { errors, payload, register, payloadData, setValue, dataRow, headCells, headCells2, bodyCells, onClickBodyRow, paperStyle, checkState, tableType, hoverEffect,cellPaddingTop,inputGroupHeight, changeFlags , disableRow,inputMargin,noScroll, editMode, notShowSearchNumber} = props;

    /* --------------------------- */
    /* ---------- state ---------- */
    /* --------------------------- */
    const [order, setOrder] = useState('asc');//データソート用
    const [orderBy, setOrderBy] = useState('');//データソート用


    //ソート情報取得用
    useEffect(() => {

        let sortInfo = {};
        sortInfo.orderBy = orderBy;
        // セッションストレージに保存する値を反転（エクセル用）
        sortInfo.order = order === 'asc' ? 'desc' : 'asc';

        /* localStorageに検索項目保存 */
        sessionStorage.setItem(SORTINFO_STORAGE, JSON.stringify(sortInfo));

    }, [order, orderBy])
    
    /* --------------------------- */
    /* -------- functions -------- */
    /* --------------------------- */
    /*------ データソート処理 ------*/
    const handleRequestSort = (event, property) => {
        // 降順ソートがかかった状態で処理実行時のみisAsc=true
        const isAsc = orderBy === property && order === 'asc';
        // 降順ソートがかかった状態で処理実行時のみ次回order=desc(降順)
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        // setDisplayData(CFSort(dataRow, isAsc ? 'desc' : 'asc', property));
        // 降順ソートがかかった状態で処理実行時のみ昇順ソート処理実行
        setValue(`${payload}`, CFSort(dataRow, isAsc ? 'asc' : 'desc', property))
    };

    /*------ sort時のTable Header ------*/
    const createSortHandler = (property) => (event) => {
        handleRequestSort(event, property);
    };

    const checkColor = (status, day) => {
        let a = CFSort(status, 'asc', 'completionDate')[0].processStatusCode;
        // a = CFArrayFount(statusMaster.list,'value', a);
        a = a.colorlist
        let resultColor;
        if (a[2].day === 'none') {
            resultColor = 'none'
        } else if (a[2].day <= day) {
            resultColor = a[2].color;//赤
        } else if (a[1].day <= day) {
            resultColor = a[1].color;//黄
        } else if (a[0].day <= day) {
            resultColor = a[0].color;//青
        } else if (a[2].day > day) {
            resultColor = 'none'
        }
        return resultColor
    }
    let size = 0; //boderやpadding分があるので初期は12;
    /* テーブルサイズの計算 */
    headCells.forEach((item) => {
        size = !(item.sizeNone) ? size + Number(item.width.replace('px', '')) + 4 : undefined;
    });
    /*------ ソートの矢印の上下を変更する処理 ------*/
    const NoneSortLabel = (props) =>{
        const {headCell} = props;
        return(
            <SdivNoneSortLabel style={{ 
                // display: headCell.blockHead ? 'block' : 'flex',
                textAlign: headCell.align, 
                fontSize: assets().size.baseText, 
                whiteSpace: headCell.nowrap ? 'nowrap' : ''}} className='baseText'
            >
                <SlabelHead style={{
                    textAlign: headCell.align1 ? headCell.align1 : headCell.align, 
                }}>
                    {headCell.label1}
                </SlabelHead>
                {headCell.label2 === undefined ? <></> : <><br/><SlabelHead>{headCell.label2}</SlabelHead></>}
            </SdivNoneSortLabel>
        )
    }
    /*------ ソートの矢印の上下を変更する処理 ------*/
    const SortLabelArrow = (props) => {
        const { headCell, id, label, label2 } = props;
        return (
            <SdivSort onClick={createSortHandler(headCell[id])} >
                <SdivSortLabel style={{ justifyContent: headCell.align, fontSize: assets().size.baseText }} className='baseText'>
                    <div style={{textAlign: headCell.align}}>
                        {headCell[label]}
                        {label2 ? <><br />{headCell[label2]}</> : ''}
                    </div>
                    {(headCell.required && editMode) &&
                        <SlabelRequireMark>＊</SlabelRequireMark>
                    }
                    {orderBy === headCell[id] ? order === 'asc' ?
                        // ソート用のアイコン　上むき
                        <SsvgFilterIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                            <use xlinkHref={`${arrowUnder}#arrowUnder`}></use>
                        </SsvgFilterIcon>
                        :
                        // ソート用のアイコン　下向き
                        <SsvgFilterIcon className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth }}>
                            <use xlinkHref={`${arrowTop}#arrowTop`}></use>
                        </SsvgFilterIcon>
                        : <></>}
                </SdivSortLabel>
            </SdivSort>
        )
    };
    /* ===　全チェックした時の処理　=== */
	const onClickAllCheck = (event,id) => {
        payloadData.forEach((element, index) => {
            setValue(`${payload}[${index}].${id}`,event.target.checked);

        });
	}
    /* === cellの色をチェック === */
    const checkCellColor = (row, col) => {
        if(!row)return;
        // データに含まれるかのチェック
        // otherItemCheck:{item:'upItemName',color:assets().color.lightYellow}
        if(row[col?.otherItemCheck?.item]?.includes(col.name)){
            return col.otherItemCheck.color;
        }
        // 値がチェック対象の値と一致するかのチェック
        // valueCheck:{value:null, color:assets().color.pink}
        else if(col.valueCheck && (row[col.name] === col?.valueCheck?.value)){
            return col.valueCheck.color;
        };

        //行ごと変える処理
        if(row.acptaRquValiFlag === 'false' || row.acptaRquValiFlag === false){ //受入申請が無効(受入中止)
            return assets().color.lightGray
        }else if(row.asiFlag === 'false'|| row.asiFlag === false){ //受入申請が無効(受入中止)従業員一覧
            return assets().color.lightGray
        }else if(row.moveInFlag === 'true'|| row.moveInFlag === true){ //当月に転入した 従業員一覧
            return assets().color.lightYellow
        }else if(row.rtnSttFlag === true || row.rtnSttFlag === 'true') { // 出向社員(出)情報一覧　帰任済フラグ
            return assets().color.lightGray
        }else if(row.dataType === 'delete'){
            return assets().color.lightGray
        }else {
            return col?.color
        }
    };
    /*--------------------------*/
    /*------ Start Render ------*/
    /*--------------------------*/
    return (
        <>
            {/* テーブル外枠 */}
            <SdivTableGroup>
                {/* テーブル内枠 */}
                <SdivPaper
                    noScroll={noScroll}
                    // className='tableHeightsize'
                    style={paperStyle ? paperStyle : { maxHeight: assets().size.tableHeightsize }}>
                    {/* style={{height:'50px'}}> */}
                    {/* テーブル */}
                    <Stable
                        className='tableStyle'
                        style={{ width: size ? size * assets().size.tableCell : null }}
                    >
                        <tbody >
                            {/* テーブルヘッダー */}
                            <StrTableHeadRow>
                                {headCells.map((headCell, headIndex) => (
                                        // テーブルヘッダーセル
                                        <SthFixedHeadCell
                                            className='tableCellStyle'
                                            colSpan={headCell.colspan}
                                            rowSpan={headCell.rowSpan}
                                            key={`${headCell.id}${headIndex}`}
                                            style={{ 
                                                width: headCell.borderRight? Number(headCell.width.replace('px', '')) * assets().size.tableCell -1 : Number(headCell.width.replace('px', '')) * assets().size.tableCell, 
                                                justifyContent: headCell.align, 
                                                backgroundColor: headCell.backgroundColor, 
                                                color: headCell.color, left: headCell.left ? Number(headCell.left?.replace('px', '')) * assets().size.tableCell : '', 
                                                borderRight: headCell.borderRight, 
                                                whiteSpace: headCell.nowrap ? 'nowrap' : 'normal', 
                                                position: headCell.fixed ? 'sticky' :'' }}
                                        >
                                            {/* sort true */}
                                            {headCell.sortTable && !editMode?
                                                <>
                                                    <SortLabelArrow
                                                        id='id'
                                                        label='label1'
                                                        label2='label2'
                                                        headCell={headCell} 
                                                    />
                                                </>
                                                :
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: headCell.align,
                                                }}>
                                                    {/* ソート無しのラベル */}
                                                    <NoneSortLabel headCell={headCell}/>
                                                    {(headCell.required && editMode) &&
                                                        <SlabelRequireMark>＊</SlabelRequireMark>
                                                    }
                                                </div>
                                            }
                                           
                                            { headCell.check ?
                                            
                                                <TableCheck
                                                    id={headCell.name}
                                                    disabled={headCell.disabled}
                                                    errorMessage={errors[payload]?.[headCell.id]?.message}
                                                    defaultChecked={headCell.defaultChecked}
                                                    register={register(`tableCheck.${headCell.id}`,
                                                        {
                                                            onChange:(e) => onClickAllCheck(e,headCell.id),
                                                            required: headCell.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                        })
                                                    }/>
                                                :<></>                                       
                                            }
                                            
                                        </SthFixedHeadCell>
                                ))
                                }
                            </StrTableHeadRow>
                            {headCells2 && 
                                <StrTableHeadRow style={{zIndex: 29, top: '40px'}}>
                                {headCells2.map((headCell2, headIndex) => (
                                        // テーブルヘッダーセル
                                        <SthFixedHeadCell
                                            className='tableCellStyle'
                                            colSpan={headCell2.colspan}
                                            rowSpan={headCell2.rowSpan}
                                            key={`${headCell2.id}${headIndex}`}
                                            style={{ 
                                                width: headCell2.borderRight ? 
                                                    Number(headCell2.width.replace('px', '')) * assets().size.tableCell -1 
                                                :
                                                    Number(headCell2.width.replace('px', '')) * assets().size.tableCell, 
                                                justifyContent: headCell2.align, backgroundColor: headCell2.backgroundColor, color: headCell2.color, 
                                                left: headCell2.left ? 
                                                    (Number(headCell2.left.replace('px', '')) * assets().size.tableCell) 
                                                : 
                                                    '', 
                                                borderRight: headCell2.borderRight, 
                                                whiteSpace: headCell2.nowrap ? 'nowrap' : 'normal', 
                                                position: headCell2.fixed ? 'sticky' :'' 
                                            }}
                                        >
                                            {/* sort true */}
                                            {headCell2.sortTable && !editMode?
                                                <>
                                                    <SortLabelArrow
                                                        id='id'
                                                        label='label1'
                                                        label2='label2'
                                                        headCell={headCell2} 
                                                    />
                                                </>
                                                :
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: headCell2.align,
                                                }}>
                                                    {/* ソート無しのラベル */}
                                                    <NoneSortLabel headCell={headCell2}/>
                                                    {(headCell2.required && editMode) &&
                                                        <SlabelRequireMark>＊</SlabelRequireMark>
                                                    }
                                                </div>
                                            }
                                        
                                            { headCell2.check ?
                                            
                                                <TableCheck
                                                    id={headCell2.name}
                                                    disabled={headCell2.disabled}
                                                    errorMessage={errors[payload]?.[headCell2.id]?.message}
                                                    defaultChecked={headCell2.defaultChecked}
                                                    register={register(`tableCheck.${headCell2.id}`,
                                                        {
                                                            onChange:(e) => onClickAllCheck(e,headCell2.id),
                                                            required: headCell2.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                                        })
                                                    }/>
                                                :<></>                                       
                                            }
                                            
                                        </SthFixedHeadCell>
                                ))
                                }
                                </StrTableHeadRow>
                            }
                            {/* Body */}
                            {dataRow.map((row, index) =>
                                {
                                    let rowEdit;
                                    if(payloadData?.[index] && (payloadData.length === dataRow.length)){
                                        if(payloadData[index].id !== undefined && dataRow[index].id !== undefined){
                                            rowEdit = dataRow.find(item => item.id === payloadData[index].id);
                                        }else{
                                            rowEdit = row;
                                        }
                                       
                                    }else{
                                        rowEdit = row;
                                    };
                                    return (
                                        // テーブル行
                                        <StrTableRow
                                            key={`${index}row`}
                                            // onClick={onClickBodyRow ? event => onClickBodyRow(event, row) : () => ''}
                                            onDragOver={(event) => event.preventDefault()}
                                            hoverEffect={hoverEffect}
                                        >
                                            {bodyCells.map((col, i) => {
                                                return (
                                                /* 固定テーブルデータ */
                                                col.fixed ?
                                                    // テーブルセル
                                                    <StdFixedBodyCell
                                                        onClick={!rowEdit?.acceptStop && onClickBodyRow && checkCellColor(rowEdit, col) !== assets().color.lightGray ?
                                                            col.func ? 
                                                                () => ''
                                                            :event => onClickBodyRow(event, rowEdit) 
                                                        :  () => ''}
                                                        justifyContent={col.align}
                                                        style={{
                                                            fontSize: assets().size.baseText,
                                                            textAlign: col.align,
                                                            color: col.color,
                                                            left: Number(col.left?.replace('px', '')) * assets().size.tableCell,
                                                            borderRight: col.borderRight,
                                                            backgroundColor:checkCellColor(rowEdit,col)
                                                        }}
                                                        key={`${index}_${i}_${row.id}_fix`}
                                                        className='baseText'
                                                    // onClick={() => col?.func(index, row)}
                                                    >
                                                        <BodyCellType 
                                                            row={rowEdit} 
                                                            col={col}
                                                            index={index} 
                                                            changeFlags={changeFlags} 
                                                            checkState={checkState} 
                                                            errors={errors} 
                                                            payload={payload} 
                                                            register={register}
                                                            checkColor={checkColor} 
                                                            inputGroupHeight={inputGroupHeight} 
                                                            inputMargin={inputMargin}
                                                            setValue={setValue} 
                                                            disableRow={disableRow}
                                                            payloadData={payloadData}
                                                        />
                                                    </StdFixedBodyCell>
                                                    :
                                                    // テーブルセル
                                                    <StdBodyCell
                                                        justifyContent={col.align}
                                                        style={{
                                                            borderLeft: col.borderLeft,
                                                            fontSize: assets().size.baseText, textAlign: col.align, color: col.color,
                                                            backgroundColor:checkCellColor(rowEdit, col)
                                                        }}
                                                        backgroundColor={
                                                            col.empty && !rowEdit[col.name] ?
                                                                '#ffe4e1'
                                                            : col.differ && rowEdit.changeFrag?.[col.name] ?
                                                                assets().color.lightYellow
                                                            : rowEdit[col.name] === '未準備' ?
                                                                '#FFEAEA'
                                                            : col.lender && rowEdit[col.name] === 'lending' ?
                                                                '#faeabc'
                                                            :
                                                            col.backgroundColor
                                                        }
                                                        key={`${index}_${i}_${rowEdit.id}`}
                                                        // style={{backgroundColor: 'red'}}
                                                        className='baseText'
                                                        cellPaddingTop={cellPaddingTop}//バリデーションエラーの高さ調整用
                                                        onClick={!rowEdit.acceptStop && onClickBodyRow && checkCellColor(rowEdit, col) !== assets().color.lightGray ?
                                                            col.func ? 
                                                                () => '' 
                                                            :event => onClickBodyRow(event, rowEdit) 
                                                        :  () => ''}
                                                    >
                                                        <BodyCellType 
                                                            row={rowEdit} 
                                                            col={col}
                                                            index={index} 
                                                            changeFlags={changeFlags} 
                                                            checkState={checkState} 
                                                            errors={errors} 
                                                            payload={payload} 
                                                            register={register}
                                                            checkColor={checkColor}
                                                            inputGroupHeight={inputGroupHeight} 
                                                            inputMargin={inputMargin}
                                                            setValue={setValue} 
                                                            disableRow={disableRow}
                                                            payloadData={payloadData}
                                                        />
                                                    </StdBodyCell>
                                            )})}
                                        </StrTableRow>
                                    )
                            })}
                        </tbody>
                    </Stable>
                </SdivPaper>
            </SdivTableGroup>
            {tableType === 'edit' || notShowSearchNumber ?
                <></>
                :
                <div className='baseText' style={{ fontSize: assets().size.baseText }}>
                    <div>検索件数:{dataRow?.length}件</div>
                </div>
            }
        </>
    );
};

const BodyCellType = (props) => {
    const { row, col, index, changeFlags, checkState, errors, payload, register, inputGroupHeight, inputMargin, disableRow, payloadData } = props;
    
    let value = row[col.name];
    if(row[col.name2] || row[col.name3] || row[col.name4]){
        value += row[col.name2] ? ' ' + row[col.name2] : ''
        value += row[col.name3] ? ' ' + row[col.name3] : ''
        value += row[col.name4] ? ' ' + row[col.name4] : ''
    }

    /* 変更項目の値のチェック */
    const changeFlagCheck = () =>{
        let result;
        /* col.name2の設定あり かつ　nameの変更がある */
        if(col.name2 && changeFlags?.[index]?.[col.name]){
            result = row[`${col.name}New`];
            row[`${col.name2}New`] &&  (result = result + ' ' + row[`${col.name2}New`]);
        }
        /* name2の設定なし　かつ　nameの変更がある */
        else if(!col.name2 && changeFlags?.[index]?.[col.name]){
            result = row[`${col.name}New`];
        };
        return result;
    };
    return (
        col.type === 'label' ? //ラベル
            <SdivLabelWrapper>
                {row.dataType === 'delete' ?
                    <div>{value}</div>
                :
                    row.dataType === 'register' ?
                    changeFlags?.[index]?.[col.name] && <div style={{color: 'red'}}>{changeFlagCheck()}</div>
                :
                    <>
                        {changeFlags?.[index]?.[col.name] ?
                            <>
                            <div>{value.length > 45 ? `${value.substr( 0, 45 )}...`:value}</div>
                            <div> ↓</div>
                            <div style={{color: 'red'}}>{changeFlagCheck()}</div>
                            </>
                            :
                            <div>{value}</div>
                        }
                    </>
                }
            </SdivLabelWrapper>
        :col.type === 'moneyLabel' ? //ラベル
            <SdivLabelWrapper>
                {row.dataType === 'delete' ?
                   <div>{Number(value)?.toLocaleString()}</div>
                :
                    row.dataType === 'register' ?
                    <div style={{color: 'red'}}>{changeFlags?.[index]?.[col.name] && Number(row[`${col.name}New`])?.toLocaleString()}</div>
                :
                    <>
                        <div>{value ? Number(value).toLocaleString() : null}</div>
                        <div>{changeFlags?.[index]?.[col.name] && '↓'}</div>
                <div style={{color: 'red'}}>{changeFlags?.[index]?.[col.name] && Number(row[`${col.name}New`])?.toLocaleString()}</div>
                    </>
                }
            </SdivLabelWrapper>
        : col.type === 'tableNumber' ? //テーブル番号
            <SdivLabelWrapper>
            {(index + 1).toString()}
            </SdivLabelWrapper>
        : col.type === 'edit' ?//codeからlabelに直して表示
            <SdivLabelWrapper>
                {row.dataType === 'delete' ?
                    <div>{value === '未入力' ?  value : CFStingMasterEdit(col.master, value)}</div>
                :
                    row.dataType === 'register' ?
                    <div style={{color: 'red'}}>{changeFlags?.[index]?.[col.name] && row[`${col.name}New`] === '未入力' ?  row[`${col.name}New`] : CFStingMasterEdit(col.master, row[`${col.name}New`])}</div>
                :
                    <>
                        <div>{value === '未入力' ?  value : CFStingMasterEdit(col.master, value)}</div>
                        <div>{changeFlags?.[index]?.[col.name] && '↓'}</div>
                        <div style={{color: 'red'}}>{changeFlags?.[index]?.[col.name] && row[`${col.name}New`] === '未入力' ?  row[`${col.name}New`] : CFStingMasterEdit(col.master, row[`${col.name}New`])}</div>
                    </>
                }
            </SdivLabelWrapper>
        : col.type === 'timeLabel' ?//日時の表示
            <SdivLabelWrapper>
                {row.dataType === 'delete' ?
                    <div>{
                        value === '未入力' ?
                        value 
                        :<p style={{margin: '0'}}>{CFDateTimeFormatEdit(value)?.split(/\s+/g,)[0]}<br />{CFDateTimeFormatEdit(value)?.split(/\s+/g,)[1]}</p>}
                    </div>
                :
                    row.dataType === 'register' ?
                        <div style={{color: 'red'}}>
                        {
                            changeFlags?.[index]?.[col.name] && row[`${col.name}New`] === '未入力' ?
                            row[`${col.name}New`] 
                            :<p style={{margin: '0'}}>{CFDateTimeFormatEdit(value)?.split(/\s+/g,)[0]}<br />{CFDateTimeFormatEdit(value)?.split(/\s+/g,)[1]}</p>
                        }
                    </div>
                :
                    <>
                        <div>
                            {
                                value === '未入力' ?
                                value 
                                :<p style={{margin: '0'}}>{CFDateTimeFormatEdit(value)?.split(/\s+/g,)[0]}<br />{CFDateTimeFormatEdit(value)?.split(/\s+/g,)[1]}</p>
                            }
                        </div>
                        {changeFlags?.[index]?.[col.name] && <div>↓</div>}
                        {
                            changeFlags?.[index]?.[col.name] ?
                                row[`${col.name}New`] === '未入力' ?
                                <div style={{color: 'red'}}>{row[`${col.name}New`]}</div>
                                :<div style={{color: 'red'}}>{CFDateTimeFormatEdit(row[`${col.name}New`])?.split(/\s+/g,)[0]}<br />{CFDateTimeFormatEdit(row[`${col.name}New`])?.split(/\s+/g,)[1]}</div>
                            :''
                        }
                        
                    </>
                }
            </SdivLabelWrapper>

        : col.type === 'dateLabel' ?//日付
            <div style={{margin: '0'}}>
                {row.dataType === 'delete' ?
                   <div>
                   {CFDateEdit(value)?.split(/\s+/g,)[0]}<br />{CFDateEdit(value)?.split(/\s+/g,)[1]}
                   </div>
                :
                    row.dataType === 'register' ?
                    <div style={{color: 'red'}}>
                            {changeFlags?.[index]?.[col.name] && (<>{CFDateEdit(row[`${col.name}New`])?.split(/\s+/g,)[0]}<br />{CFDateEdit(row[`${col.name}New`])?.split(/\s+/g,)[1]}</>)}
                    </div>
                :
                    <>
                       <div>
                        {CFDateEdit(value)?.split(/\s+/g,)[0]}<br />{CFDateEdit(value)?.split(/\s+/g,)[1]}
                        </div>
                        <div>{changeFlags?.[index]?.[col.name] && '↓'}</div>
                        <div style={{color: 'red'}}>
                            {changeFlags?.[index]?.[col.name] && (<>{CFDateEdit(row[`${col.name}New`])?.split(/\s+/g,)[0]}<br />{CFDateEdit(row[`${col.name}New`])?.split(/\s+/g,)[1]}</>)}
                        </div>
                    </>
                }
            </div>
        : col.type === 'checked' ?
            <>
                <TableCheckOnChange
                // id={row.incidentId}
                value={row.incidentId}
                checked={checkState.some((u) => u.tieIncidentId === row.incidentId)}
                onChange={event => col.onChange(event, row.incidentNumber)}
                // readOnly={items.readOnly}
                />
            </>
        : col.type === 'input' ?
            <TableInputField
                errorMessage={errors[payload]?.[index]?.[col.name]?.message}
                disabled={col.check && payloadData?.[index]?.[col.checkItem] === col.checkValue ? true : col.disabled}
                readOnly={col.readOnly}
                maxLength={col.maxLength}
                placeholder={col.placeholder}
                align={col.align}
                isDirty={value !== payloadData?.[index]?.[col.name]}
                inputGroupHeight={inputGroupHeight}//バリデーションエラーの高さ調整用
                boxStyle={inputMargin ? {marginRight:'10px'}: {marginRight: '0'}}
                register={register(`${payload}.${index}.${col.name}`,
                {
                    value:row[col.name2] ? value + ' ' + row[col.name2] : value,
                    required: col.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                    minLength: { value: col.minLength ? col.minLength : '', message: CFArrayFount(inputCheckMaster.list, 'value', 'min').label },
                    maxLength: { value: col.maxLength ? col.maxLength : '', message: CFArrayFount(inputCheckMaster.list, 'value', 'max').label },
                    pattern: {
                    value: col.pattern ? CFArrayFount(patternCheckMaster.list, 'value', col.pattern).detailItemValidationTypeCode : CFArrayFount(patternCheckMaster.list, 'value', 'space').detailItemValidationTypeCode,
                    message: col.pattern ? CFArrayFount(patternCheckMaster.list, 'value', col.pattern).label : CFArrayFount(patternCheckMaster.list, 'value', 'space').label
                }
                })}
            />
        : col.type === 'inputList' ?
            <TableInputList
                list={col.name}
                errorMessage={errors[payload]?.[index]?.[col.name]?.message}
                title={col.title}
                disabled={col.disabled}
                readOnly={col.readOnly}
                range={col.master.list} //選択肢
                maxLength={col.maxLength}
                rightLabel={col.rightLabel}
                placeholder={col.placeholder}
                isDirty={value !== payloadData?.[index]?.[col.name]}
                register={register(`${payload}.${index}.${col.name}`,
                {
                    value:value,
                    required: col.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                    minLength: { value: col.minLength ? col.minLength : '', message: CFArrayFount(inputCheckMaster.list, 'value', 'min').label },
                    maxLength: { value: col.maxLength ? col.maxLength : '', message: CFArrayFount(inputCheckMaster.list, 'value', 'max').label },
                    pattern: {
                        value: col.pattern ? CFArrayFount(patternCheckMaster.col, 'value', col.pattern).detailItemValidationTypeCode : CFArrayFount(patternCheckMaster.list, 'value', 'space').detailItemValidationTypeCode,
                        message: col.pattern ? CFArrayFount(patternCheckMaster.list, 'value', col.pattern).label : CFArrayFount(patternCheckMaster.list, 'value', 'space').label
                    },
                    validate:{
                        invalidData: v => {
                            if(!v)return;
                            let inputValue = v.split(' ')[0];
                            let inputName = v.split(' ')[1];
                            /* リストに存在しない値を入力していた場合はエラー表示 */
                            if(!CFArrayFount(col.master.list,'value',inputValue) || !CFArrayFount(col.master.list,'label',inputName)){
                                return CFArrayFount(inputCheckMaster.list, 'value', 'invalidInput').label;
                            }
                        }
                    }
                })}
            />
        : col.type === 'check' ?
            <SdivLabelWrapper>
                 {row.dataType === 'delete' ?
                    <TableCheck
                    isDirty={changeFlags?.[index]?.[col.name] === undefined && value !== payloadData?.[index]?.[col.name]}
                    // isDirty={changeFlags?.[index]?.[col.name] === undefined && (value === 'true' ? true : value === 'false' ? false : value) !== payloadData?.[index]?.[col.name]}
                    id={col.name}
                    disabled={col.disabled ? col.disabled :disableRow?.[index]?.[col.name]}
                    errorMessage={errors[payload]?.[index]?.[col.name]?.message}
                    scale={col.scale}
                    labelId={`${payload}.${index}.${col.name}`}
                    register={register(`${payload}.${index}.${col.name}`,
                    {
                        required: col.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                        value:value
                    })}/>
                :
                    row.dataType === 'register' ?
                    <TableCnfCheck
                        defaultChecked={row[`${col.name}New`]}
                    />
                :
                    <>
                        <TableCheck
                            isDirty={changeFlags?.[index]?.[col.name] === undefined && value !== payloadData?.[index]?.[col.name]}
                            id={col.name}
                            disabled={col.disabled ? col.disabled :disableRow?.[index]?.[col.name]}
                            errorMessage={errors[payload]?.[index]?.[col.name]?.message}
                            scale={col.scale}
                            labelId={`${payload}.${index}.${col.name}`}
                            register={register(`${payload}.${index}.${col.name}`,
                            {
                                required: col.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                                value:value=== '未入力' ? false : value=== 'true' ? true:value=== 'false' ? false : value
                            })}/>
                        <div style={{alignItems:'center'}}>{changeFlags?.[index]?.[col.name] && '↓'}</div>
                        <div style={{padding:'0 1px'}}>
                            {
                                changeFlags?.[index]?.[col.name] &&
                                    <TableCnfCheck
                                        defaultChecked={row[`${col.name}New`]}
                                    />
                            }
                        </div>
                    </>
                }                    
            </SdivLabelWrapper>
           
        : col.type === 'select' ?
            <TableSelectB
            isDirty={value !== payloadData?.[index]?.[col.name]}
                errorMessage={errors[payload]?.[index]?.[col.name]?.message}
                register={register(`${payload}.${index}.${col.name}`,
                {
                    value:value === true ? 'true':value === 'false' ? false : value,
                    required: col.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                    deps: col.deps ? col.deps.map((item) => `${payload}.${index}.${item}`) : null
                })}
                range={col.master.list} //選択肢
                noHidden={!col.required}
                disabled={col.check && col.checkValue.includes(payloadData?.[index]?.[col.checkItem]) ? true : col.disabled}
                // disabled={col.disabled}
                readOnly={col.readOnly}
            />
        : col.type === 'date' ? //日時表示
            <TableDateField
                isDirty={value !== payloadData?.[index]?.[col.name]}
                errorMessage={errors[payload]?.[index]?.[col.name]?.message}
                register={register(`${payload}.${index}.${col.name}`,
                {
                    value:value,
                    required: col.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
                    pattern: {
                        value: col.pattern ? CFArrayFount(patternCheckMaster.list, 'value', col.pattern)?.detailItemValidationTypeCode : CFArrayFount(patternCheckMaster.list, 'value', 'space')?.detailItemValidationTypeCode,
                        message: col.pattern ? CFArrayFount(patternCheckMaster.list, 'value', col.pattern).label : CFArrayFount(patternCheckMaster.list, 'value', 'space').label
                    },
                    deps: [`payload.${index}.${col.startDate}`,`payload.${index}.${col.endDate}`,`payload.${index}.${col.checkItem}`],//startDateとendDateがバリデーション発生した場合同様にエラー表示                                                                     
                    validate:{
                        //startDateよりendDateが大きい場合にエラーを発生させる
                        invalidDate: v => {
                            if(col.startDate){                             
                                if(v && payloadData?.[index]?.[col.startDate]){
                                    // v > startDate
                                    if(new Date(v) > new Date(payloadData?.[index]?.[col.startDate])){
                                        return true;
                                    // v < startDate     
                                    }else{
                                        return CFArrayFount(inputCheckMaster.list, 'value', 'date').label;
                                    }
                                };
                            }else if(col.endDate){
                                if(v && payloadData?.[index]?.[col.endDate]){
                                    // endDate > v
                                    if(new Date(payloadData?.[index]?.[col.endDate]) > new Date(v)){
                                        return true;
                                    // endDate < v   
                                    }else{
                                        return CFArrayFount(inputCheckMaster.list, 'value', 'date').label;
                                    };                                                                                            
                                };
                            };
                        },
                        requiredIfCheckItemExists: (value) => { // col.checkItemで指定したペイロードがcol.checkValueと異なる値の場合、必須項目にする
                            if (!col.checkItem) {
                                return;
                            }
                            if (payloadData?.[index]?.[col.checkItem] === col.checkValue) {
                                return;
                            };
                            return value ? null : CFArrayFount(inputCheckMaster.list, 'value', 'required').label
                        }
                    }
                })}
                disabled={col.check && payloadData?.[index]?.[col.checkItem] === col.checkValue ? true : col.disabled}
                readOnly={col.readOnly}
                type='date'
            />
        // : col.type === 'radioButton' ? //ラジオボタン
        //     <SdivLabelGroup key={col.name} style={{ color: col.color }} >
        //         {col.range.list.map((itemsChild, i) =>
        //         <div key={`${itemsChild.value}${i}`}>
        //             <TableRadio
        //                 id={itemsChild.value}
        //                 label={itemsChild.label}
        //                 disabled={col.check && payloadData?.[index]?.[col.checkItem] === col.checkValue ? true : col.disabled}
        //                 value={itemsChild.value}
        //                 // defaultChecked={value === itemsChild.value}
        //                 register={register(`${payload}.${index}.${col.name}`,
        //                     {
        //                         value:value,
        //                         // onChange: (e) => setValue(`${payload}.${items.name}`,e.target.value),
        //                         // disabled: items.disabled,
        //                         required: col.required ? CFArrayFount(inputCheckMaster.list, 'value', 'required').label : '',
        //                     })}
        //             // readOnly={items.readOnly}
        //             />
        //         </div>
        //         )}
        //     {/* <InputErrorMessage errorMessage={error[payload]?.[items.name]?.message}/>                              */}
        //     </SdivLabelGroup>
        : col.type === 'editButton' ? //編集ボタン
            <SsvgIconButton onClick={() => col.func(row)} className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth, color: assets().color.green }}>
                <use xlinkHref={`${pencil}#pencil`}></use>
            </SsvgIconButton>
        : col.type === 'outputButton' ? //出力
            <ButtonIconExcelTabel
                onClick={()=>col.func(row)}/>
        : col.type === 'authorityChangeButton' ? //権限参照ボタン
            <SsvgIconButton onClick={()=>col.func(row)} className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth, color: assets().color.blue }}>
                <use xlinkHref={`${people}#people`}></use>
            </SsvgIconButton>
        : col.type === 'invalidButton' ? //無効ボタン
            <SsvgIconButton onClick={col.func} className='svgStyle' style={{ height: assets().size.svgHeight, width: assets().size.svgWidth, color: assets().color.blue }}>
                <use xlinkHref={`${people}#people`}></use>
            </SsvgIconButton>
: <></>

    )
}

//使い方

//  /****** テーブルの設定　*****/
//     /*------ ヘッダの設定 ------*/
//     // id       : 項目名
//     // rowSpan  : 2~ (縦に結合)
//     // colSpan	: 2~ (横に結合)
//     // align	: 整列(横方向) Center/inherit/justify/left/right
//     // sortTable: true(ソート)
//     // fixed	: 位置固定 true
//     // left		: 左からの位置	0~
//     // right	: 右からの位置 0~
//     // width    : セルの幅
//     // label1	: 表示名(1段目)
//     // label2	: 表示名(2段目)

//     const headData = [
//     	{ id: 'a', align: 'center', width: '90px',color:'#333333',backgroundColor:'#C4E6EB', sortTable:true, label1: '問合せ日'},//問合せ日
//     	{ id: 'b', align: 'center', width: '90px',color:'#333333',backgroundColor:'#C4E6EB', sortTable:true, label1: '問合せ区分' },//問合せ区分
//     	{ id: 'c', align: 'center', width: '90px',color:'#333333',backgroundColor:'#C4E6EB', sortTable:true, label1: '種別詳細' },//種別詳細
//     	{ id: 'd', align: 'center', width: '90px',color:'#333333',backgroundColor:'#C4E6EB', sortTable:true, label1: '問合せ内容' },//問合せ内容
//     	{ id: 'e', align: 'center', width: '90px',color:'#333333',backgroundColor:'#C4E6EB', sortTable:true, label1: '対応状況' },//対応状況
//     	{ id: 'f', align: 'center', width: '90px',color:'#333333',backgroundColor:'#C4E6EB', sortTable:true, label1: '最終更新日' },//最終更新日
//     	{ id: 'g', align: 'center', width: '90px',color:'#333333',backgroundColor:'#C4E6EB', sortTable:true, label1: '' },//ボタン
//     	{ id: 'h', align: 'center', width: '90px',color:'#333333',backgroundColor:'#C4E6EB', sortTable:true, label1: '' },//ボタン
//     ];
//     /*------ BodyCellの設定　 ------*/
//     // name		    : 項目名
//     // type         : cellの種類　button/checkBox/lable/numLable/labelRaito/labelMonth
//     // align	    : 整列(横方向) Center/inherit/justify/left/right *全て（ただしinputの場合はinputの中の文字の位置を指定）
//     // width        : selectの幅調整用
//     // color        : 文字の色
//     // backgroundColor: 背景の色
//     // checkBox     : チェックボックスの名前  *input,checkBox
//     // fontSize	    : 文字の大きさ デフォルトは12px *label,labelNum
//     // color	    : フォントカラーまたはアイコンカラー(アイコンの場合はred/green/grayが選択可能) *label,labelNum,iconButton
//     // func         : 処理 *button,iconButton,select
//     // value		: btnFuncで受け取りたい値 *button,iconButton

//     const bodyData = [
//         { name: 'a', type: 'label',  align: 'center'},
//         { name: 'b', type: 'label',  align: 'center'},
//         { name: 'c', type: 'label',  align: 'right'},
//         { name: 'd', type: 'label',  align: 'center'},
//         { name: 'e', type: 'label',  align: 'center'},
//         { name: 'f', type: 'label',  align: 'center'},
//         { name: 'g', type: 'button',  align: 'center'},
//         { name: 'h', type: 'button',  align: 'center'},
//     ];

//     //ダミーデータ
// const members = [
//     {a: '3/31',b:'問合せ',c:'パソコン',d:'OSが起動しない',e:'2022/4/2 9:00'},
//     {a: '3/20',b:'問合せ',c:'パソコン',d:'OSが起動しない',e:'2022/4/2 9:00'},
//     {a: '3/1',b:'問合せ',c:'パソコン',d:'OSが起動しない',e:'2022/4/2 9:00'},
//     {a: '3/3',b:'問合せ',c:'パソコン',d:'OSが起動しない',e:'2022/4/2 9:00'},
// ];


//<Table
//   headCells={headData} //ヘッダの設定情報
//    bodyCells={bodyData} //ボディの設定情報
//    dataRow={members}//表示データ
//    tableSize={1031}	//テーブルサイズ(ヘッダサイズのトータル)
//    paperStyle={{maxHeight:'calc(100vh - 150px)'}} //高さはここ
///> 